import EventsWebservice from './EventsWebservice';
import { blumarWebserviceAxios } from './HttpHelper';

let axios = blumarWebserviceAxios();

export default class EventOptionService extends EventsWebservice{
	constructor() {
		super('/events');
	}
	findByEventId(id) {
		return axios.get(`${this.url}/options/${id}`);
	}
}



// WEBPACK FOOTER //
// ./src/services/EventOptionService.js